<template>
  <div :class="['has-margin no-border goods-list']">

    <!-- end商品折扣优惠信息展示 -->
    <div class="itm">
      <!-- check -->
      <div class="check">
        <van-checkbox
          v-show="false "
          v-model="item.checked"
          :disabled=" !item.Stock || item.IsOutBusinessScope || item.IsPutaway !== 1 || item.IsControll"
          shape="square"
          checked-color="#0F6EE9"
          @change="$emit('itemCheckedChanged')"
        />
      </div>

      <!-- 商品图片 -->
      <div class="gimg" :class="{'minGimg':isAlwaysBuysCom,gimg:true}" @click="cleckItem(item)">
        <van-image
          :width="isAlwaysBuysCom ? 60 : 100"
          :height="isAlwaysBuysCom ? 60 : 100"
          :src="_getPic(item.Logo, true)"
          fit="contain"
        />
        <div v-if="activityCode === 4" class="mask">换购</div>
        <div v-if="activityCode === 3" class="mask">满赠</div>
      </div>
      <!-- 商品info -->
      <div class="gcontent" @click="cleckItem(item)">
        <div class="gname van-ellipsis">
          <!-- 新品标签 -->
          <div style=" margin-right: 4px; font-size: 0;">
            <img style="width: 30px;" src="@/assets/goods/new.png">
          </div>
          <!-- 商品标签 -->
          <img
            v-if="item.GoodsTags && item.GoodsTags.length"
            :src="item.GoodsTags[0].Img"
            style="margin-right: 4px; width: 32px; height: 16px;"
          >
          <div style="flex: 1;" class="ellips-text">
            {{ item.OperationName || item.SkuName }}
          </div>
        </div>
        <!-- 规格 -->
        <div class="gtag van-ellipsis">规格：{{ item.Specifications }}/{{ item.Unit }}</div>
        <template v-for="(itemChild, index) in item.CommodityListProperties">
          <div
            v-if="itemChild.Abbreviation === '效'"
            :key="index"
            class="gtag van-ellipsis"
            :title="itemChild.Value"
          >
            效期：{{ itemChild.AttributeName }}{{ itemChild.Value }}
          </div>
        </template>
        <!-- 商品标签 -->
        <div class="tag-list">
          <div v-for="(val,idx) in goodsTagList" :key="idx" :class="['tag-box','tag-type-'+val.type]">{{ val.txt }}</div>
        </div>
      </div>
      <!-- price -->
      <div class="gprice" :style="{'width':isAlwaysBuysCom? '142px':'200px'}">

        <!-- 商品价格 -->
        <div>￥{{ item.PriceLimit }}</div>
        <!-- 商品原价 -->
        <s v-if="activityCode === 4 && item.Stock && !item.IsOutBusinessScope && !item.IsControll && item.IsPutaway === 1" class="origin-price fAvenirH">￥{{ item.Price }}</s>
      </div>

      <!-- 数量 -->
      <!-- 赠品展示逻辑 -->
      <div class="gamount">
        <template v-if="activityCode === 3">

          <template v-if="!item.Stock">
            <span style="color: #FF3939;">库存不足，无法{{ activityCode === 4 ? '换购' : '赠送' }}</span>
          </template>

          <template v-else>
            <div style="font-size: 14px; color: #0F6EEA;">数量：{{ num > 0 ? item.Count.mul(num) : item.Count }}</div>
          </template>
        </template>

        <template v-if="activityCode === 4">
          <div v-if="item.IsOutBusinessScope" class="error_btn">超出经营范围</div>
          <div v-else-if="item.IsControll" class="error_btn">已被控销</div>
          <div v-else-if="item.IsPutaway !== 1" class="error_btn">已下架</div>
          <div v-else-if="!item.Stock" class="no_stock">
            <span>库存不足，无法换购</span>
          </div>
          <div v-else style="font-size: 14px; color: #0F6EEA;">数量：{{ num > 0 ? item.Count.mul(num) : item.Count }}</div>
        </template>
        <template v-if="item.Stock" />
      </div>
      <!-- 小计 -->
      <div v-show="activityCode ===4 && showPriceLimitCount" class="gtotal ">
        ￥{{ _moneyFormat(item.Count*item.PriceLimit) }}
      </div>
      <!-- 删除操作 -->
      <div v-if="!isAlwaysBuysCom" class="gaction">
        <template v-if="item.IsSoldOut">
          <div v-if="item.ArrivalNotice" class="to-msg-btn is-get">已订阅</div>
          <div v-if="!item.ArrivalNotice" class="to-msg-btn" @click.stop="SubNotice">到货通知</div>
        </template>

        <div v-if="item.IsOutBusinessScope" class="to-msg-btn">超出经营范围</div>
      </div>
    </div>
    <!-- 多商品 -->

    <!-- 商品活动信息 -->

  </div>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
import moment from 'moment'
export default {
  name: 'BuyCarGiftList',
  mixins: [BaseMixin],
  props: {
    // 数据类型 赠品-1,换购-2
    dataType: {
      type: Number,
      default: 0
    },
    isAlwaysBuysCom: {
      // 是否快速下单页组件
      type: Boolean,
      default: false
    },
    // 小类类型 折扣 128
    typeCode: {
      type: Number,
      default: null
    },
    // 大类类型
    activityCode: {
      type: Number,
      default: null
    },

    item: {
      type: Object,
      default: () => ({
        checked: true,
        ProductName: '测试商品'
      })
    },
    // 每满赠满足次数
    num: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      goodsTagList: []

    }
  },
  computed: {
    showPriceLimitCount() {
      const goodsInfo = this.item
      if (!goodsInfo) return false
      return !goodsInfo.IsOutBusinessScope && !goodsInfo.IsControll && goodsInfo.IsPutaway === 1 && goodsInfo.Stock
    }
  },
  watch: {
    item: {
      handler(val) {
        if (val) {
          this.type = val.ActivityCode
          this.goodsTagList = []
          val.ActivityCode ? this.goodsTagList.push({ type: 1, txt: this.getConfigType(val.ActivityCode) }) : null
          val.MedicalType ? this.goodsTagList.push({ type: 2, txt: val.MedicalType }) : null
          val.CountryCode ? this.goodsTagList.push({ type: 3, txt: '国家码' }) : null
        }
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {},
  methods: {
    moment,
    // 获取商品实际价格
    _getProductPrice(price1, price2) {
      if (!price1 && !price2) {
        return 0
      }
      let price = price2
      if (price1 && price1 <= price2) {
        price = price1
      }
      return price
    },
    // 到货通知
    async SubNotice() {
      const data = await this.postAction('/api_customer/CustomerCollect/Create', {
        CollectType: 3,
        CollectingBusinessId: this.item.SkuId,
        CollectionPrice: this._getProductPrice(
          this.item.ActivityPrice,
          this.item.PriceLimit
        )
      })
      if (!data.IsSuccess) {
        this.$toast({ position: 'bottom', message: data.Msg })
      } else {
        if (data.Data) {
          this.$parent.syncCurrentSourceData(this.ListIndex, this.ActivityListIndex, this.GoodsSkusIndex, 'ArrivalNotice', true)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.goods-list {
  position: relative;
  display: flex;
  justify-content: flex-start;
  overflow-x: hidden;
  border: 1px solid rgba(232, 232, 232, 1);
  border-radius: 2px;
  padding-bottom: 16px;
  min-height: 172px;
  color: #222222;
  background-color: #FFFFFF;
  flex-direction: column;

  .activity-type {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 32px 16px 60px;
    border-radius: 2px;
    padding: 6px 33px 6px 12px;
    width: 1108px;
    height: 26px;
    font-size: 14px;
    color: #111A34;
    background: #FFEEEC;

    .red-num {
      color: rgba(255, 57, 57, 1);
    }

    .gray-txt {
      color: rgba(102, 111, 131, 1);
    }

    .left-txt {
      font-weight: bold;
    }

    .right-txt {
      font-size: 14px;
      color: rgba(255, 57, 57, 1);

      &:hover {
        cursor: pointer;
      }
    }
  }

  .tag-list {
    >div {
      display: inline-block;
    }

    .tag-box {
      margin-right: 4px;
      padding: 2px 4px;
      height: 18px;
      font-size: 12px;
      text-align: center;
    }

    .tag-type-1 {
      border: 1px solid #FE3F3F;
      color: #FE3F3F;
    }

    .tag-type-2 {
      border: 1px solid #019491;
      color: #019491;
    }

    .tag-type-3 {
      border: 1px solid #06B266;
      color: #06B266;
    }

    .tag-release {
      border-radius: 2px;
      padding: 4px 0 4px 8px;
      width: 140px;
      height: 20px;
      font-size: 12px;
      color: #111A34;
      background: linear-gradient(294deg, rgba(249, 250, 251, 0) 0%, #F0F3F5 100%);
    }

    .red-release {
      background: linear-gradient(294deg, rgba(249, 250, 251, 0) 0%, #FFF1F0 100%);
    }
  }

  .ellips-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.has-margin {
    margin-bottom: 16px;
  }

  &.no-border {
    border: none;
  }

  .itm {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    margin-bottom: 16px;
    margin-left: 158px;

    .check {
      display: flex;
      align-items: center;
      margin-left: 20px;
    }

    .minGimg {
      width: 60px !important;
      height: 60px !important;
    }

    .gimg {
      position: relative;
      margin-left: 20px;
      width: 100px;
      height: 100px;
      cursor: pointer;

      /deep/ img {
        background: rgba(243, 245, 248, 1);
      }

      .mask {
        position: absolute;
        right: 0;
        bottom: 0;
        border-radius: 0 0 4px 4px;
        border-radius: 4px 0;
        width: 56px;
        height: 20px;
        font-size: 12px;
        text-align: center;
        color: #FFFFFF;
        background: rgba(15, 110, 233, .7);
        line-height: 20px;
      }
    }
    // 新品名称等信息
    .gcontent {
      display: flex;
      padding-top: 17px;
      padding-left: 20px;
      // width: 376px;
      width: 184px;
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      flex-direction: column;
      cursor: pointer;
      line-height: 1;

      .gname {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        font-weight: 500;
        color: #111A34;
      }

      .gtag {
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 400;
        color: #666F83;
      }
    }

    .gprice {
      padding-top: 24px;
      width: 200px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 1;

      .active-price {
        display: inline-block;
        margin-bottom: 8px;
        border-radius: 4px;
        padding: 0 7px 0 5px;
        height: 20px;
        font-size: 12px;
        color: #FFFFFF;
        background: linear-gradient(137deg, #FF6831 0%, #F3180E 100%);
        line-height: 20px;

        .unit {
          position: relative;
          top: -2px;
          font-size: 16px;
          vertical-align: middle;
        }
      }
      // 原价
      .origin-price {
        display: block;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #858B9C;
      }
      // over time
      .over-time {
        position: relative;
        display: inline-block;
        margin-top: 12px;
        border-radius: 4px;
        padding: 0 6px;
        min-width: 140px;
        height: 16px;
        font-size: 12px;
        color: #FF3939;
        background: #FFEEEC;
        line-height: 16px;

        &::after {
          position: absolute;
          top: -5px;
          left: 50%;
          display: block;
          border-right: 5px solid transparent;
          border-bottom: 5px solid #FFEEEC;
          border-left: 5px solid transparent;
          width: 5px;
          content: '';
          transform: translateX(-50%);
        }

        .img-fire img {
          margin-bottom: 4px;
          width: 12px;
          height: 12px;
        }
      }
    }

    .gamount {
      padding-top: 16px;
      width: 234px;
      font-size: 16px;

      /deep/ .van-stepper__plus::after {
        width: 2px;
      }

      /deep/ .van-stepper__plus::before {
        height: 2px;
      }

      /deep/ .van-stepper__minus::before {
        height: 2px;
      }

      /deep/ .van-stepper__plus {
        color: rgba(65, 72, 93, 1);
      }

      /deep/ .van-stepper {
        border: 1px solid #C5CAD5;
        border-radius: 6px;

        .van-stepper__input {
          margin: 0;
          border-right: 1px solid #C5CAD5;
          border-left: 1px solid #C5CAD5;
          width: 54px;
          background-color: #F7F8FA;

          .van-stepper__minus,
          .van-stepper__plus {
            color: #41485D;
            background-color: rgba(197, 202, 213, 1);
          }
        }
      }
    }

    .gtotal {
      padding-top: 24px;
      width: 100px;
      font-size: 16px;
      color: #222222;
      line-height: 1;
    }
  }
  // 商品活动容器
  .goods-active-panel {
    // position: relative;
    // padding-left: 60px;
    padding-top: 16px;
    // display: flex;
  }

  .line {
    margin: 20px 46px 7px 74px;
    height: 1px;
    background-color: rgba(242, 242, 242, .4);
  }

  .gactive {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    flex-direction: row;

    .active-tag {
      border-radius: 2px;
      padding: 3px 14px;
      color: #FFFFFF;
      background: rgba(255, 57, 57, 1);
    }

    .active-tag-txt {
      color: rgba(255, 57, 57, 1);
    }

    .active-text {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 10px;
      flex-direction: row;
    }
  }
}

.checked {
  background: #F9FAFB;
}

/deep/ .van-stepper {
  input {
    margin: 0;
    border: 1px solid #C5CAD5;
    border-right: 0;
    border-left: 0;
    width: 47px;
    height: 32px;
    font-size: 16px;
    cursor: pointer;
  }

  button {
    border: 1px solid #C5CAD5;
    width: 35px;
    height: 32px;
    color: #41485D;
    background: rgba(246, 246, 246, 1);

    &.van-stepper__minus {
      border-radius: 2px 0 0 2px;
    }

    &.van-stepper__plus {
      border-radius: 0 2px 2px 0;
    }

    &::before {
      width: 12px;
      height: 2px;
    }

    &::after {
      width: 2px;
      height: 12px;
    }
  }
}

.gaction {
  margin-left: 62px;
  padding-top: 20px;
  width: 76px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  line-height: 22px;
  cursor: pointer;

  .to-msg-btn {
    margin-bottom: 11px;
    border-radius: 2px;
    width: 72px;
    height: 22px;
    text-align: center;
    color: #FFFFFF;
    background-color: #0F6EEA;
    line-height: 22px;

    &.is-get {
      background: #C5CAD5;
    }
  }
}

.inputNumber {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, .7);

  &-d {
    position: absolute;
    top: 30%;
    display: flex;
    align-items: flex-start;
    margin-left: 25vw;
    border-radius: 15px;
    padding: 20px 20px 10px;
    width: 50vw;
    height: 137px;
    background-color: #FFFFFF;
    box-sizing: border-box;
    flex-direction: column;
  }

  &-amout {
    margin-bottom: 10px;
  }

  &-input {
    border: none;
    border-bottom: 1px #FF5500 solid;
    width: 100%;
  }

  &-bottons {
    margin-top: 10px;
    width: 100%;
    cursor: pointer;
  }

  .input-enter,
  .input-cancel {
    float: right;
    margin-left: 30px;
    padding: 10px 0;
    color: rgb(255, 85, 0);
  }
}

.error_btn {
  text-align: center;
  color: #FA5F5F;
}
</style>
